import React from 'react';

import classes from '../../../../../App.module.css';

const ParamsList = () => {
    return (
        <ul className={classes.ParamsList}>
            <li>
                <b>locale </b>
                <i>
                    the locale based on which the formatting will be done
                    <b>*</b>
                </i>
            </li>
            <li>
                <b>value </b>
                <i>
                    the actual amount to be formatted<b>*</b>
                </i>
            </li>
            <li>
                <b>numberOfDecimals </b>{' '}
                <i>the number of digits you want as decimals</i>
                <b>*</b>
            </li>
            <li>
                <b>currency </b>{' '}
                <i>the currency based on which the formatting will be done</i>
                <b>*</b>
            </li>
            <li>
                <b>customCurrency </b>
                <i>
                    object with properties which makes the util return even more
                    customized values; you can override the currency position,
                    its symbol, its separator/decimal separator and can set
                    different overrides for different markets<b>*</b>
                </i>
            </li>
            <li>
                <b>customerSettingsData </b>
                <i>
                    object with additional options that can be customized -{' '}
                    <b>milliSeperator</b> and <b>enableStakeDecimals</b>
                </i>
            </li>
        </ul>
    );
};

export default ParamsList;
